import { makeAutoObservable } from 'mobx';
import * as queryString from 'query-string';
import apiConfig from '../api/routes';
import { ListSpecialDaysPayloadI } from '../components/calendar/CalendarPage';
import { UserStore } from './User';

class SpecialDays {

  constructor() {
    makeAutoObservable(this);
  }

  getListSpecialDays = async (data: ListSpecialDaysPayloadI) => {
    let params = {...data};
    const userStore = UserStore;
    if(data.user_id){
      const id = data.user_id;
      params = {...params, user_id:id};
    }
    else{
      params = {...params, user_id: userStore.profile.id as unknown as  number };
    }
    return await apiConfig.specialDaysService.getList(queryString.stringify(params));
  };
}

const SpecialDaysStore = new SpecialDays();

export default SpecialDaysStore;